export type TestPrefillConfig = {
  customerId: string;
  partId: string;
  carMaker?: string;
  remarks?: string;
  orderDate?: string;
  shipmentAddress?: {
    _id?: string;
    addressLine1: string;
    addressLine2?: string;
    city: string;
    state: string;
    pinCode?: string;
    country?: string;
    countryCode?: string;
    isDefault?: boolean;
    location?: {
      latitude: number;
      longitude: number;
    };
  };
  billingDetails?: {
    billingEntity: string;
    name: string;
    gst?: string;
    address: {
      addressLine1: string;
      addressLine2?: string;
      city: string;
      state: string;
      pinCode?: string;
      country?: string;
    };
  };
};

export type TestPrefillDefaults = {
  customerId: string;
  partId: string;
  carMaker: string;
  remarks: string;
  orderDate: Date;
  shipmentAddress: TestPrefillConfig["shipmentAddress"] | null;
  billingDetails: TestPrefillConfig["billingDetails"] | null;
};

const EMPTY_DEFAULTS: TestPrefillDefaults = {
  customerId: "",
  partId: "",
  carMaker: "",
  remarks: "",
  orderDate: new Date(),
  shipmentAddress: null,
  billingDetails: null,
};

export const parseTestPrefillConfigRaw = (
  raw?: string | null,
): TestPrefillConfig | null => {
  const trimmed = raw?.trim();
  if (!trimmed) return null;
  try {
    return JSON.parse(trimmed) as TestPrefillConfig;
  } catch {
    return null;
  }
};

export const buildTestPrefillDefaults = (
  config: TestPrefillConfig | null,
): TestPrefillDefaults => {
  if (!config) return { ...EMPTY_DEFAULTS, orderDate: new Date() };

  const shipmentAddress = config.shipmentAddress?.addressLine1
    ? config.shipmentAddress
    : null;

  const orderDate = config.orderDate
    ? new Date(config.orderDate)
    : new Date();

  return {
    customerId: config.customerId ?? "",
    partId: config.partId ?? "",
    carMaker: config.carMaker ?? "",
    remarks: config.remarks ?? "",
    orderDate: Number.isNaN(orderDate.getTime()) ? new Date() : orderDate,
    shipmentAddress,
    billingDetails: config.billingDetails ?? null,
  };
};
